<div class="loading" [hidden]="!isDelayedRunning">
  <div class="loading">
    <div class="loading-container">
      <div class="spinner-image">
        <svg
          version="1.1"
          id="Artwork"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 126 126"
          enable-background="new 0 0 126 126"
          xml:space="preserve"
        >
          <g id="Symbol_with_Clearspace">
            <g>
              <rect id="Clearspace" x="0" fill="none" width="126" height="126" />
              <path
                style="fill: white"
                id="Symbol"
                d="M63,29.9c18.3,0,33.1,14.9,33.1,33.1c0,18.3-14.9,33.1-33.1,33.1c-18.3,0-33.1-14.9-33.1-33.1
            C29.9,44.7,44.7,29.9,63,29.9 M63,27c-19.9,0-36,16.1-36,36c0,19.9,16.1,36,36,36s36-16.1,36-36C99,43.1,82.9,27,63,27L63,27z
             M75.6,38.2l-19.1,6.6v-4.8h-8.5v7.8L41.2,50l-6.6,15c0.1,0.2,0.7,4,0.7,4c3.3-0.9,6.7-1.3,10.3-1.3c14.6,0,27.4,7.9,34.3,19.6
            l1.9-1.2c-1.2-2-2.5-3.9-4-5.6V67.8l-8.4-1.5v6.6c-5.9-4.1-12.9-6.7-20.5-7.2c11.7-3.5,21.4-11.8,26.4-22.7l9.9,22.7l2.6,0.5
            L75.6,38.2z M71.6,68.9l4,0.7v8.4c-1.3-1.3-2.6-2.5-4-3.6V68.9z M36.9,65.3l5.9-13.5l7.3-2.5v-7.2h4.1v5.7l19.3-6.7
            C67.5,55.3,53.2,65,36.9,65.3z M73.7,56.8l1.9,0.3V61l-1.9-0.3V56.8 M71.5,54.2v8.3l6.3,1.1v-8.3L71.5,54.2L71.5,54.2z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="spinner-image--border-animation"></div>
    </div>
  </div>
</div>
